module.exports = __webpack_public_path__ + "img/icon-white-21.eff517b3.svg";